(function () {
  const COUNT_SELECTOR = '[data-reviews-member-count]';

  function formatCount(value) {
    return Math.round(value).toLocaleString('en-US');
  }

  function animateCount(el, start, end, duration) {
    const startTime = performance.now();

    function tick(now) {
      const progress = Math.min((now - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const value = start + (end - start) * eased;

      el.textContent = formatCount(value);

      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        el.textContent = formatCount(end);
      }
    }

    requestAnimationFrame(tick);
  }

  function initCount(el) {
    if (!el || el.dataset.countAnimated === 'true') return;

    const start = parseInt(el.dataset.countStart, 10);
    const end = parseInt(el.dataset.countEnd, 10);

    if (!Number.isFinite(start) || !Number.isFinite(end) || start >= end) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.textContent = formatCount(end);
      el.dataset.countAnimated = 'true';
      return;
    }

    el.textContent = formatCount(start);

    const observeTarget = el.closest('.shopify-section') || el;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          observer.disconnect();
          el.dataset.countAnimated = 'true';
          animateCount(el, start, end, 20000);
        });
      },
      { threshold: 0.35 }
    );

    observer.observe(observeTarget);
  }

  function boot(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(COUNT_SELECTOR).forEach(initCount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    boot(event.target);
  });
})();
